import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import EventsCouponImpl from './events-coupon.js';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays an events coupon.
 *
 * @class EventsCoupon
 * @memberof Mojito.Modules
 */

/**
 * `EventsCoupon` prop types.
 *
 * @property {string} sportId - Sport id.
 * @property {string} [eventGroupsId] - Event groups id.
 * @property {string|Function} [headerText] - Text used as header. If function is provided then it will be called to resolve header text with the list of presented event groups.
 * @property {boolean} [isInPlay = false] - If true, the coupon is related to in-play events. Defaults to false.
 * @property {boolean} [isLiveAndFuture = false] - If true, the coupon contains both live and future events.
 * @property {boolean} [isInPlayStreaming = false] - If true, the coupon is related to in-play events with streaming. Defaults to false.
 * @property {boolean} [isFavorites] - If true, the coupon renders the user's favorite events.
 * @property {string} [analyticsName] - Identification name for analytics.
 * @property {Function} [onShowAllButtonClick = ()=>{}] - Callback executed when the 'Show All' button is clicked.
 * @property {Function} [onDataLoad = () => {}] - Callback executed when all the component's data and its child components' data have loaded.
 * @property {boolean} [enableSorting = false] - Flag to control sorting availability. It's used to prevent unsupported sorting.
 * @property {boolean} [isOutrights = false] - Flag used to determine whether component is rendered within outrights.
 * @property {boolean} [shouldRequestData = true] - Flag indicating whether component should request event groups data from content. If false, then event groups will not be requested, hence in order to present info corresponding data should be already available in a store.
 * @property {boolean} [isCouponNavigation = false] - When true, the navigation button redirects to the coupon or type page.
 *
 * @memberof Mojito.Modules.EventsCoupon
 */
const propTypes = {
    sportId: PropTypes.string,
    eventGroupsId: PropTypes.string,
    headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    isInPlay: PropTypes.bool,
    isLiveAndFuture: PropTypes.bool,
    isInPlayStreaming: PropTypes.bool,
    isFavorites: PropTypes.bool,
    analyticsName: PropTypes.string,
    onDataLoad: PropTypes.func,
    onShowAllButtonClick: PropTypes.func,
    enableSorting: PropTypes.bool,
    isOutrights: PropTypes.bool,
    shouldRequestData: PropTypes.bool,
    isCouponNavigation: PropTypes.bool,
};

const defaultProps = {
    isInPlay: false,
    isLiveAndFuture: false,
    isInPlayStreaming: false,
    isFavorites: false,
    shouldRequestData: true,
    isCouponNavigation: false,
    onShowAllButtonClick: noop,
    onDataLoad: noop,
    enableSorting: false,
    isOutrights: false,
};

export default UIView('EventsCoupon', EventsCouponImpl, propTypes, defaultProps);
